import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({ basename: import.meta.env.BASE_URL });

let prevLocation = null;
let activeUnblockFunctions = new Set();

browserHistory.listen((_, action) => {
  if (action === 'PUSH') {
    prevLocation = browserHistory.location;
  }
});

export function getPreviousLocation() {
  return prevLocation;
}

export function registerNavigationBlocker(unblockFn) {
  activeUnblockFunctions.add(unblockFn);
  return () => activeUnblockFunctions.delete(unblockFn);
}

export function temporarilyDisableAllNavigationBlockers() {
  // Temporarily remove all navigation blockers
  const currentBlockers = Array.from(activeUnblockFunctions);
  currentBlockers.forEach((unblock) => {
    if (typeof unblock === 'function') {
      unblock();
    }
  });
  activeUnblockFunctions.clear();
  return currentBlockers;
}

export function forcePush(path, state) {
  // Disable all navigation blockers temporarily
  temporarilyDisableAllNavigationBlockers();

  // Perform the navigation
  browserHistory.push(path, state);
}

export function forceReplace(path, state) {
  // Disable all navigation blockers temporarily
  temporarilyDisableAllNavigationBlockers();

  // Perform the navigation
  browserHistory.replace(path, state);
}

export default browserHistory;
